import { render, staticRenderFns } from "./SelectRepo.vue?vue&type=template&id=3607a62a&"
import script from "./SelectRepo.vue?vue&type=script&lang=js&"
export * from "./SelectRepo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports